export default __webpack_public_path__ + "static/media/mahindra.db46d72b.webp";